import GroupTreeModal from './GroupTreeModal';

export default GroupTreeModal;
